import {CATEGORY_BY_ALIAS_MAP} from '@/store/getterTypes';

export default {
  [CATEGORY_BY_ALIAS_MAP](state) {
    return Object.fromEntries(
        Object.values(state.eventCategoriesById)?.map((i) => [i.alias, i]),
    );
  },
};
